import type { Container } from '@tencent/alloy-renderer';
import { ComponentWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-wrapper';
import { ComponentAnimWrapper } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-anim-wrapper';

/**
 * 找到顶层的图形挂载节点
 * @param component 分支上的某个component
 */
export const getTopContainer = (component: Container): Container | undefined => {
    let parentContainer = component?.parent;
    // 找到图形的wrapper节点
    while (parentContainer && !(parentContainer instanceof ComponentWrapper)) {
        parentContainer = parentContainer.parent;
    }
    // 如果有动画wrapper嵌套，则指向动画wrapper
    const topContainer = parentContainer?.parent instanceof ComponentAnimWrapper
        ? parentContainer?.parent : parentContainer;
    return topContainer ? topContainer : undefined;
};
